import * as yup from 'yup'
import atLeastOneCharacter from './atLeastOneCharacter'
import atLeastOneNumber from './atLeastOneNumber'
import atLeastOneSimbol from './atLeastOneSimbol'
import nullableValidString from './nullableValidString'
import phone from './phone'
import name from './name'
import validateCPF from './validateCPF'

yup.addMethod(yup.string, 'name', name)
yup.addMethod(yup.string, 'phone', phone)
yup.addMethod(yup.string, 'atLeastOneNumber', atLeastOneNumber)
yup.addMethod(yup.string, 'atLeastOneCharacter', atLeastOneCharacter)
yup.addMethod(yup.string, 'atLeastOneSimbol', atLeastOneSimbol)
yup.addMethod(yup.string, 'nullableValidString', nullableValidString)
yup.addMethod(yup.string, 'validateCPF', validateCPF)

export * from 'yup'
